import paymentInstance from '../../../instance'
import paymentModalLoginInstance from '../../../modalLoginInstance'

const accountDetails = (hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).get('/tap2pay/accountDetails')
}

export default accountDetails
